//import fetch from 'cross-fetch'
// import Parser from 'rss-parser/dist/rss-parser.min.js'
// import Parser from 'rss-parser'
import DOMPurify from 'isomorphic-dompurify'

export const REQUEST_HOT100 = 'REQUEST_HOT100'
export const RECEIVE_HOT100 = 'RECEIVE_HOT100'
export const REQUEST_HOT100_ARCHIVE = 'REQUEST_HOT100_ARCHIVE'
export const RECEIVE_HOT100_ARCHIVE = 'RECEIVE_HOT100_ARCHIVE'
export const INVALIDATE_HOT100 = 'INVALIDATE_HOT100'
export const HOT100_POSITION = 'HOT100_POSITION'
export const REQUEST_TOP20 = 'REQUEST_TOP20'
export const RECEIVE_TOP20 = 'RECEIVE_TOP20'
export const REQUEST_TOP20_COUNTER = 'REQUEST_TOP20_COUNTER'
export const RECEIVE_TOP20_COUNTER = 'RECEIVE_TOP20_COUNTER'
export const INVALIDATE_TOP20 = 'INVALIDATE_TOP20'
export const REQUEST_PRIZES = 'REQUEST_PRIZES'
export const RECEIVE_PRIZES = 'RECEIVE_PRIZES'
export const INVALIDATE_PRIZES = 'INVALIDATE_PRIZES'
export const REQUEST_RADIOTHON_DAILY = 'REQUEST_RADIOTHON_DAILY'
export const RECEIVE_RADIOTHON_DAILY = 'RECEIVE_RADIOTHON_DAILY'
export const INVALIDATE_RADIOTHON_DAILY = 'INVALIDATE_RADIOTHON_DAILY'
export const REQUEST_STATION_UPDATES = 'REQUEST_STATION_UPDATES'
export const RECEIVE_STATION_UPDATES = 'RECEIVE_STATION_UPDATES'
export const INVALIDATE_STATION_UPDATES = 'INVALIDATE_STATION_UPDATES'
export const REQUEST_BNA = 'REQUEST_BNA'
export const RECEIVE_BNA = 'RECEIVE_BNA'
export const INVALIDATE_BNA = 'INVALIDATE_BNA'
export const REQUEST_AOTW = 'REQUEST_AOTW'
export const RECEIVE_AOTW = 'RECEIVE_AOTW'
export const INVALIDATE_AOTW = 'INVALIDATE_AOTW'
export const REQUEST_EOY_TOP10_FULL = 'REQUEST_EOY_TOP10_FULL'
export const REQUEST_EOY_TOP10 = 'REQUEST_EOY_TOP10'
export const RECEIVE_EOY_TOP10_FULL = 'RECEIVE_EOY_TOP10_FULL'
export const RECEIVE_EOY_TOP10 = 'RECEIVE_EOY_TOP10'
export const INVALIDATE_EOY_TOP10 = 'INVALIDATE_EOY_TOP10'
export const REQUEST_PODCAST = 'REQUEST_PODCAST';
export const RECEIVE_PODCAST = 'RECEIVE_PODCAST';

export function invalidateTop20() {
  return {
    type: INVALIDATE_TOP20
  }
}

function requestTop20() {
  return {
    type: REQUEST_TOP20
  }
}

function receiveTop20(json) {
  let top20 = json[0].body[0].value

  top20 = DOMPurify.sanitize(top20, {ALLOWED_TAGS: [], ALLOWED_ATTR: [] })

  // let top20set = top20.match(/.*?\/n/g);
  let top20set = top20.split(/\r?\n/);
  top20set = top20set.filter(n => n)
  top20set.map((x, i) => {
    // x = x.replace(/<p>(.*?)<\/p>/g, '$1')
    let parts = x.match(/(\d*)\. (.*) - (.*)/)
    if(parts) {
      top20set[i] = { pos: parts[1], artist: String(parts[2]).trim(), title: String(parts[3]).trim()}
    }
    else {
      let parts = x.match(/(.*) - (.*)/)
      if(parts) {
        top20set[i] = { pos: i + 1, artist: String(parts[1]).trim(), title: String(parts[2]).trim()}
      }
    }
  })
  return {
    type: RECEIVE_TOP20,
    top20: json[0],
    top20set: top20set,
    receivedAt: Date.now()
  }
}

function fetchTop20() {
  return dispatch => {
    dispatch(requestTop20())
    return fetch('//jeff.4zzz.org.au/api/top20?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveTop20(json)))
  }
}

function shouldFetchTop20(state) {
  const top20 = state.top20
  if (top20.items.length === 0) {
    return true
  } else if (top20.isFetching) {
    return false
  } else {
    return top20.didInvalidate
  }
}

export function fetchTop20IfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchTop20(getState())) {
      return dispatch(fetchTop20())
    }
  }
}

function requestTop20Counter() {
  return {
    type: REQUEST_TOP20_COUNTER
  }
}

function receiveTop20Counter(json) {
  return {
    type: RECEIVE_TOP20_COUNTER,
    top20Counter: json,
  }
}

export function fetchTop20Counter() {
  return dispatch => {
    dispatch(requestTop20Counter())
    return fetch('https://data.4zzz.org.au/musicDB/top20')
      .then(response => response.json())
      .then(json => dispatch(receiveTop20Counter(json)))
  }
}

export function invalidateHot100() {
  return {
    type: INVALIDATE_HOT100
  }
}

function requestHot100Archive() {
  return {
    type: REQUEST_HOT100_ARCHIVE
  }
}

function receiveHot100Archive(json) {
  return {
    type: RECEIVE_HOT100_ARCHIVE,
    hot100Archive: json,
    receivedAt: Date.now()
  }
}

export function fetchHot100Archive() {
  return dispatch => {
    dispatch(requestHot100Archive())
    return fetch('https://4zzz.org.au/zzz/hot100-archive')
      .then(response => response.json())
      .then(json => dispatch(receiveHot100Archive(json)))
  }
}

function requestHot100() {
  return {
    type: REQUEST_HOT100
  }
}

function receiveHot100(json) {
  return {
    type: RECEIVE_HOT100,
    hot100: json,
    receivedAt: Date.now()
  }
}


function positionHot100(data) {
  return {
    type: HOT100_POSITION,
    hot100Position: data,
    receivedAt: Date.now()
  }
}

function fetchHot100() {
  return dispatch => {
    dispatch(requestHot100())
    return fetch('https://data.4zzz.org.au/musicDB/hot100-private')
      .then(response => response.json())
      .then(json => dispatch(receiveHot100(json)))
  }
}

export function setHot100Position(position) {
  return (dispatch, getState) => {
    dispatch(positionHot100(position.trim()))
    dispatch(invalidateHot100())
    dispatch(fetchHot100IfNeeded())
  }
}

export function fetchHot100Position() {
  return (dispatch, getState) => {
    return fetch('https://data.4zzz.org.au/musicDB/hot100', {cache: "no-store"})
      .then(response => response.text())
      .then(text => {
        if( getState().hot100.position !== text.trim() ) {
          dispatch(positionHot100(text.trim()))
          dispatch(invalidateHot100())
          dispatch(fetchHot100IfNeeded())

        }
      })
  }
}


function shouldFetchHot100(state) {
  const hot100 = state.hot100
  if (hot100.items.length === 0) {
    return true
  } else if (hot100.isFetching) {
    return false
  } else {
    return hot100.didInvalidate
  }
}

export function fetchHot100IfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchHot100(getState())) {
      return dispatch(fetchHot100())
    }
  }
}

//PRIZES
export function invalidatePrizes(category) {
  return {
    type: INVALIDATE_PRIZES,
    category: category,
  }
}

function requestPrizes(category) {
  return {
    type: REQUEST_PRIZES,
    category: category,
  }
}

function receivePrizes(category, json) {
  return {
    type: RECEIVE_PRIZES,
    category: category,
    prizes: json,
    receivedAt: Date.now()
  }
}

function fetchPrizes(category) {
  return dispatch => {
    dispatch(requestPrizes(category))
    let type = ''
    switch(category) {
      case 'monthly': {
        type = '/Monthly Subscriber Prize'
        break;
      }
      case 'radiothon': {
        type = '/Radiothon Prize'
        break;
      }
      case 'april-atonement': {
        type = '/April Atonement Prize'
        break;
      }
    }
    return fetch('//jeff.4zzz.org.au/api/prizes'+ type +'?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receivePrizes(category, json)))
  }
}

function shouldFetchPrizes(category, state) {
  const prizes = state.prizes
  if (prizes.items.length === 0) {
    return true
  }
  else if (prizes.category !== category) {
    return true
  } 
  else if (prizes.isFetching) {
    return false
  } else {
    return prizes.didInvalidate
  }
}

export function fetchPrizesIfNeeded(category) {
  return (dispatch, getState) => {
    if (shouldFetchPrizes(category, getState())) {
      return dispatch(fetchPrizes(category))
    }
  }
}

//RADIOTHON DAILY
export function invalidateRadiothonDaily() {
  return {
    type: INVALIDATE_RADIOTHON_DAILY
  }
}

function requestRadiothonDaily() {
  return {
    type: REQUEST_RADIOTHON_DAILY
  }
}

function receiveRadiothonDaily(json) {
  return {
    type: RECEIVE_RADIOTHON_DAILY,
    radiothonDaily: json,
    receivedAt: Date.now()
  }
}

function fetchRadiothonDaily() {
  return dispatch => {
    dispatch(requestRadiothonDaily())
    return fetch('//jeff.4zzz.org.au/api/radiothondailyprizes?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveRadiothonDaily(json)))
  }
}

function shouldFetchRadiothonDaily(state) {
  const radiothonDaily = state.radiothonDaily
  if (radiothonDaily.items.length === 0) {
    return true
  } else if (radiothonDaily.isFetching) {
    return false
  } else {
    return radiothonDaily.didInvalidate
  }
}

export function fetchRadiothonDailyIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchRadiothonDaily(getState())) {
      return dispatch(fetchRadiothonDaily())
    }
  }
}

//STATION UPDATES
export function invalidateStationUpdates() {
  return {
    type: INVALIDATE_STATION_UPDATES
  }
}

function requestStationUpdates() {
  return {
    type: REQUEST_STATION_UPDATES
  }
}

function receiveStationUpdates(json) {
  return {
    type: RECEIVE_STATION_UPDATES,
    stationUpdates: json,
    receivedAt: Date.now()
  }
}

function fetchStationUpdates() {
  return dispatch => {
    dispatch(requestStationUpdates())
    return fetch('//jeff.4zzz.org.au/api/station-updates?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveStationUpdates(json)))
  }
}

function shouldFetchStationUpdates(state) {
  const stationUpdates = state.stationUpdates
  if (stationUpdates.items.length === 0) {
    return true
  } else if (stationUpdates.isFetching) {
    return false
  } else {
    return stationUpdates.didInvalidate
  }
}

export function fetchStationUpdatesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchStationUpdates(getState())) {
      return dispatch(fetchStationUpdates())
    }
  }
}


export function invalidateAOTW() {
  return {
    type: INVALIDATE_AOTW
  }
}

function requestAOTW() {
  return {
    type: REQUEST_AOTW
  }
}

function receiveAOTW(json) {
  return {
    type: RECEIVE_AOTW,
    AOTW: json,
    receivedAt: Date.now()
  }
}

function fetchAOTW() {
  return dispatch => {
    dispatch(requestAOTW())
    return fetch('//jeff.4zzz.org.au/api/album-of-the-week?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveAOTW(json)))
  }
}

function shouldFetchAOTW(state) {
  const AOTW = state.AOTW
  if (AOTW.items.length === 0) {
    return true
  } else if (AOTW.isFetching) {
    return false
  } else {
    return AOTW.didInvalidate
  }
}

export function fetchAOTWIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchAOTW(getState())) {
      return dispatch(fetchAOTW())
    }
  }
}

export function invalidateBNA() {
  return {
    type: INVALIDATE_BNA
  }
}

function requestBNA() {
  return {
    type: REQUEST_BNA
  }
}

function receiveBNA(json) {
  return {
    type: RECEIVE_BNA,
    BNA: json,
    receivedAt: Date.now()
  }
}

function fetchBNA() {
  return dispatch => {
    dispatch(requestBNA())
    return fetch('//jeff.4zzz.org.au/api/bna?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveBNA(json)))
  }
}

function shouldFetchBNA(state) {
  const BNA = state.BNA
  if (BNA.items.length === 0) {
    return true
  } else if (BNA.isFetching) {
    return false
  } else {
    return BNA.didInvalidate
  }
}

export function fetchBNAIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchBNA(getState())) {
      return dispatch(fetchBNA())
    }
  }
}

export function invalidateEOYTop10() {
  return {
    type: INVALIDATE_EOY_TOP10
  }
}

function requestEOYTop10() {
  return {
    type: REQUEST_EOY_TOP10
  }
}

function receiveEOYTop10(json) {
  return {
    type: RECEIVE_EOY_TOP10,
    EOYTop10: json,
    receivedAt: Date.now()
  }
}

function fetchEOYTop10() {
  return dispatch => {
    dispatch(requestEOYTop10())
    return fetch('//jeff.4zzz.org.au/api/eoy-top-10?_format=json&' + Math.floor(Date.now() / 1000))
      .then(response => response.json())
      .then(json => dispatch(receiveEOYTop10(json)))
  }
}

function shouldFetchEOYTop10(state) {
  const EOYTop10 = state.EOYTop10
  if (EOYTop10.items.length === 0) {
    return true
  } else if (EOYTop10.isFetching) {
    return false
  } else {
    return EOYTop10.didInvalidate
  }
}

export function fetchEOYTop10IfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchEOYTop10(getState())) {
      return dispatch(fetchEOYTop10())
    }
  }
}

function requestEOYTop10Full() {
  return {
    type: REQUEST_EOY_TOP10_FULL
  }
}

function receiveEOYTop10Full(json) {
  return {
    type: RECEIVE_EOY_TOP10_FULL,
    EOYTop10Full: json,
    receivedAt: Date.now()
  }
}

function fetchEOYTop10Full() {
  return dispatch => {
    dispatch(requestEOYTop10())
    return fetch('//jeff.4zzz.org.au/api/eoy-top-10/full?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveEOYTop10Full(json)))
  }
}

function shouldFetchEOYTop10Full(state) {
  const EOYTop10 = state.EOYTop10
  if (EOYTop10.full.length === 0) {
    return true
  } else if (EOYTop10.isFetchingFull) {
    return false
  } else {
    return EOYTop10.didInvalidateFull
  }
}

export function fetchEOYTop10FullIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchEOYTop10Full(getState())) {
      return dispatch(fetchEOYTop10Full())
    }
  }
}

function requestPodcast() {
	return { type: REQUEST_PODCAST }
}

function receivePodcast(feed) {
	return {
		type: RECEIVE_PODCAST,
		feed: feed
	}
}

function fetchPodcast() {
  return dispatch => {
    dispatch(requestPodcast())
    return fetch('https://data.4zzz.org.au/from-a-to-triple-zed')
      .then(response => response.json())
      .then(json => dispatch(receivePodcast(json)))
  }
}

function shouldFetchPodcast(state) {
  const podcast = state.podcastFeed
  if (Object.keys(podcast.feed).length === 0) {
    return true
  } else if (podcast.isFetchingFull) {
    return false
  } else {
    return podcast.didInvalidateFull
  }
}

export function fetchPodcastIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchPodcast(getState())) {
      return dispatch(fetchPodcast())
    }
  }
} 
// export function fetchAndParsePodcast() {
// 	return dispatch => {
// 		let parser = new Parser({
// 		  customFields: {
// 		    item: [ ['itunes:episodeType', 'episodeType'], ]
// 		  }
// 		});
// 		dispatch(requestPodcast())
// 		return parser.parseURL('https://4zzz.org.au/feed/from-a-to-triple-zed', (err, feed) => {
// 			if (err) throw err;
// 			dispatch(receivePodcast(feed));
// 			// console.warn(feed)
// 	 })
//  }

// }
